<template>
  <div class="junhe-record">
    <img class="logo-img" src="/static/images/junhe/logo.png" alt="logo">
    
    <div class="history-container">
      <div class="glass-card">
       
       
        <div class="title-section">
            <h3>积分记录</h3>
        </div>

      
        <div class="record-list">
            <div v-for="(record, index) in records" :key="index" class="record-item">
                <div class="record-info">
                    <span class="record-label">
                        {{ record.code }}
                    </span>
                    <span class="record-date">{{ record.scantime }}</span>
                </div>
                <span class="record-amount">
                    <span class="amount-plus">+</span>{{ record.amount }}
                </span>
            </div>
        </div>
      </div>
      <div class="bottom-links">
        <span class="link-text" @click="reScan">继续扫码</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserScanRecords, getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'JunHeRecord',
  data() {
    return {
      eno: '',
      userToken: '',
      deptId: '',
      appId: process.env.ENV_NUM === '1' ? 'wx2fd80b8155ff35c2' : 'wxbc22565b3e7a59fd',
      records: []
    }
  },
  mounted() {
    this.eno = this.$route.query.eno || ''
    this.userToken = this.$route.query.userToken || ''
    this.deptId = this.$route.query.deptId || ''
    console.log('Record页面接收参数:', {
      eno: this.eno,
      userToken: this.userToken,
      deptId: this.deptId
    })
    
    this.getWxJs()
    
    if (this.eno && this.userToken) {
      this.getUserScanRecords()
    }
  },
  methods: {
    goToRule() {
      this.$router.push({
        path: '/junhe/rule',
        query: {
          deptId: this.deptId
        }
      })
    },
    async getUserScanRecords() {
      try {
        const res = await getUserScanRecords(this.eno, this.userToken)
        if (res.data.code == 200) {
          console.log('获取用户扫码记录成功:', res.data)
          const dataList = res.data.data || []
          this.records = dataList.map(item => {
            const giftValue = item.giftValue
            const amount = giftValue % 1 === 0 ? Math.floor(giftValue) : giftValue
            return {
              code: item.code,
              scantime: item.createTime,
              amount: amount
            }
          })
        } else {
          alert(res.data.msg || '获取用户扫码记录失败')
        }
      } catch (error) {
        console.error('获取用户扫码记录失败:', error)
        alert('获取用户扫码记录失败，请重试')
      }
    },
    reScan() {
      wx.scanQRCode({
        needResult: 0,
        scanType: ["qrCode"],
      });
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openEnterpriseChat',
            'openCustomerService'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      })
    }
  }
}
</script>

<style scoped>
.junhe-record {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  background: url("/static/images/junhe/bg.png") no-repeat center top;
  background-size: cover;
}

.logo-img {
  position: absolute;
  top: 3vh;
  right: 8vw;
  width: 20vw;
  height: auto;
  z-index: 10;
}

.history-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 8vh;
  padding-left: 4vw;
  padding-right: 4vw;
  min-height: 100vh;
}

.glass-card {
  margin-top: auto;
  margin-bottom: 6vh;
  position: relative;
  backdrop-filter: blur(10px);
  background: rgba(0, 16, 214, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 30px rgba(0, 16, 214, 0.2);
  border-radius: 25px;
  height: 70vh;
  display: flex;
  flex-direction: column;
}

/* Top highlight for glossy feel */
.glass-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.3), transparent);
}

.floating-icon {
  position: absolute;
  top: -6vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.icon-bg {
  background-color: white;
  color: black;
  padding: 3vw;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.2);
  border-radius: 20px;
}

.file-text-icon {
  font-size: 6vw;
}

.title-section {
  padding-top: 5vh;
  padding-bottom: 3vh;
  text-align: center;
  flex-shrink: 0;
}

.title-section h3 {
  color: white;
  font-weight: bold;
  letter-spacing: 2px;
  margin: 0;
  font-size: 5.5vw;
}

.record-list {
  flex: 1;
  overflow-y: auto;
  padding-left: 6vw;
  padding-right: 6vw;
  padding-bottom: 8vh;
  display: flex;
  flex-direction: column;
  gap: 3vh;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 10px;
  padding: 4vw;
  transition: all 0.3s ease;
}

.record-item:hover {
  background-color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.3);
}

.record-info {
  display: flex;
  flex-direction: column;
  gap: 1vh;
}

.record-label {
  color: white;
  font-size: 3.5vw;
  font-weight: 500;
  letter-spacing: 1px;
}

.record-label.is-code {
  font-family: monospace;
  color: #e0f2fe;
}

.record-date {
  color: white;
  font-size: 3vw;
  font-family: monospace;
  opacity: 0.8;
}

.record-amount {
  color: #60a5fa;
  font-weight: bold;
  font-size: 4vw;
  display: flex;
  align-items: center;
  gap: 0.5vw;
  text-shadow: 0 0 5px rgba(96, 165, 250, 0.5);
}

.amount-plus {
  font-size: 3vw;
  opacity: 0.7;
}

.bottom-links {
  position: fixed;
  bottom: 4vh;
  left: 0;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}

.link-text {
  color: white;
  font-size: 4vw;
  cursor: pointer;
}

/* 滚动条样式 */
.record-list::-webkit-scrollbar {
  width: 4px;
}

.record-list::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.record-list::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 10px;
}

.record-list::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/JunHe/Record.vue